import { render } from "./Gdpr.vue?vue&type=template&id=052d35b1"
import script from "./Gdpr.vue?vue&type=script&lang=js"
export * from "./Gdpr.vue?vue&type=script&lang=js"
script.render = render

export default script